import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

/**
 * Opens a URL in the in-app browser (iOS/Android) or new tab (web)
 * This keeps users within the app experience on mobile
 */
export const openInAppBrowser = async (url) => {
  if (!url) return;

  // Ensure URL has protocol
  let fullUrl = url;
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    fullUrl = 'https://' + url;
  }

  try {
    if (Capacitor.isNativePlatform()) {
      // Native: Use Capacitor Browser (SFSafariViewController / Chrome Custom Tabs)
      await Browser.open({
        url: fullUrl,
        // 'fullscreen' so file previews fill the screen on iPad. 'popover' rendered
        // as a small, cramped floating card on tablets; iPhone shows full-screen either way.
        presentationStyle: 'fullscreen',
        toolbarColor: '#1e40af', // Match app theme
      });
    } else {
      // Web: Open in new tab
      window.open(fullUrl, '_blank', 'noopener,noreferrer');
    }
  } catch (error) {
    console.error('Error opening browser:', error);
    // Fallback to window.open
    window.open(fullUrl, '_blank', 'noopener,noreferrer');
  }
};

/**
 * Close the in-app browser (if open)
 */
export const closeInAppBrowser = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      await Browser.close();
    }
  } catch (error) {
    console.error('Error closing browser:', error);
  }
};
